export const getInitials = (text: string | undefined | null): string => {
  if (!text) {
    return "";
  }

  const words = text.split(" ").filter((word: string) => word.length > 0);

  if (words.length === 0) {
    return "";
  }

  if (words.length === 1) {
    return words[0].at(0)?.toUpperCase() ?? "";
  }

  return `${words.at(0)?.at(0)}${words.at(-1)?.at(0)}`.toUpperCase();
};
